/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductStagingDTOFromJSON, ProductStagingDTOToJSON, } from './ProductStagingDTO';
/**
 * Check if a given object implements the PaginatedResponseProductStagingDTO interface.
 */
export function instanceOfPaginatedResponseProductStagingDTO(value) {
    return true;
}
export function PaginatedResponseProductStagingDTOFromJSON(json) {
    return PaginatedResponseProductStagingDTOFromJSONTyped(json, false);
}
export function PaginatedResponseProductStagingDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(ProductStagingDTOFromJSON)),
    };
}
export function PaginatedResponseProductStagingDTOToJSON(json) {
    return PaginatedResponseProductStagingDTOToJSONTyped(json, false);
}
export function PaginatedResponseProductStagingDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(ProductStagingDTOToJSON)),
    };
}
